import getMuiTheme from 'material-ui/styles/getMuiTheme';

import { colors, typography } from '../provider';

export default getMuiTheme({
  fontFamily: typography.fontFamily,
  palette: {
    primary1Color: colors.clrSecondary,
    primary2Color: colors.clrPrimary,
    accent1Color: colors.clrSecondary,
    pickerHeaderColor: colors.clrPrimary,
  },
  slider: {
    trackSize: 8,
    handleSize: 18,
    handleSizeActive: 24,
  },
});
